<template>
  <div class="cookie-overlay px-3">
    <v-alert v-model="cookieAlert" dark color="#0B2239">
      <v-row align="center" class="text-left">
        <v-col cols="12" sm="12" md="12" lg="10" xl="10">
          By clicking “Accept All Cookies”, you agree to the storing of cookies
          on your device to enhance site navigation, analyze site usage, and
          assist in our marketing efforts.
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="2" xl="2" class="text-right">
          <v-btn class="rounded-sm" dark color="#4AD295" @click="acceptCookie"
            >Accept All Cookies</v-btn
          >
        </v-col>
      </v-row>
    </v-alert>
  </div>
</template>

<script>
export default {
  name: "AcceptCookie",
  data() {
    return {
      cookieAlert: true
    };
  },
  mounted() {
    this.checkCookie();
  },
  methods: {
    checkCookie() {
      var result = this.getCookie("gb_patient_cookie");
      if (result == "true") {
        this.cookieAlert = false;
      }
    },
    acceptCookie() {
      this.setCookie("gb_patient_cookie", true, 365);
      this.checkCookie();
    },
    setCookie(name, value, daysToLive) {
      var cookie = name + "=" + encodeURIComponent(value);
      if (typeof daysToLive === "number") {
        cookie += "; max-age=" + daysToLive * 24 * 60 * 60;
        document.cookie = cookie;
      } else {
        document.cookie = cookie;
      }
    },
    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2)
        return parts
          .pop()
          .split(";")
          .shift();
    }
  }
};
</script>
<style>
.cookie-overlay {
  position: fixed;
  bottom: 1rem;
  z-index: 2051;
  line-height: 20px;
  width: 100% !important;
}
</style>
